export default __webpack_public_path__ + "static/media/about-us.7cee1185.png";